import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@app/services/authentication/authentication.service';
import { SettingsService } from '@app/services/api-services/settings/settings.service';
@Injectable({
  providedIn: 'root',
})
export class ImageViewerGuard {
  settings = this.settingsService.getSettingsModel();
  permissions: string[] = [];
  constructor(
      private router: Router,
      private auth: AuthenticationService,
      private settingsService: SettingsService
    ) {}

  canActivate() {
    if (this.permissions.length === 0) {
      this.auth.permissions.forEach((perm) => {
        this.permissions.push(perm.componentActionKey);
      });
    }
    // TODO - Implement this.settings.displayImageViewer check which is a part of branch PLAT-1245
    if (this.permissions.length > 0) {
      if (this.permissions.includes('view_image_viewer')) {
        return true;
      } else {
        this.router.navigateByUrl('/cases');
        return false;
      };
    }
  }

}